<div class="tracker-main p-0">
    <div class="container start-container">
        <div class="row marginTop">
            <div class="col-sm-12">
                <div class="cookie-policy">
                    <p style="text-align: justify" [innerHTML]="cookieInformation">

                    </p>
                    <br/>
                </div>
                <a href="javascript:void(0);" class="btn bluebtn" (click)="redirectToHome()" translate>lblBackToStart</a>
            </div>
        </div>
    </div>
</div>